<template>
    <div class="class-1">
      <!-- Header -->
      <AppHeader title="Delivery Companies" />
  
      <!-- Add New Delivery Company Button -->
      <button class="add-delivery-company-btn" @click="navigateToAddDeliveryCompany">Add New Delivery Company</button>
  
      <!-- Table Structure -->
      <table id="deliveryCompanyTable">
        <thead>
          <tr>
            <th>Name (English)</th>
            <th>Name (Arabic)</th>
            <th>Status</th>
            <th>Operations</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(company, index) in deliveryCompanies" :key="index">
            <!-- <td>{{ company.id }}</td> -->
            <td>{{ company.name_en }}</td>
            <td>{{ company.name_ar }}</td>
            <td :class="company.is_active ? '' : ''">
              {{ company.is_active ? 'Active' : 'Inactive' }}
            </td>
            <td class="action-buttons">
              <button data-tooltip="Edit" @click="handleEdit(company)">
                <img src="@/assets/edit_icon.png" alt="Edit">
              </button>
              <button 
                data-tooltip="Delete" 
                @click="handleDelete(company)"
                class="delete-btn"
              >
                <img src="@/assets/delete_icon.png" alt="Delete">
              </button>
              <button 
                :data-tooltip="company.is_active ? 'Deactivate' : 'Activate'" 
                @click="handleToggleStatus(company)"
                :class="company.is_active ? 'deactivate-btn' : 'activate-btn'"
              >
                <img 
                  :src="company.is_active ? 
                    require('@/assets/suspend_icon.png') : 
                    require('@/assets/activate_icon.png')" 
                  :alt="company.is_active ? 'Deactivate' : 'Activate'"
                >
                {{ company.is_active ? '' : '' }}
              </button>
                <button 
                class="btn-payment"
                @click="handleRecordPayment(company)"
                data-tooltip="Record Payment"
              >
                <i style="filter: invert(50%) sepia(100%) saturate(500%) hue-rotate(180deg);" class="fas fa-hand-holding-usd"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</template>
  <script>
  export default {
    data() {
      return {
        deliveryCompanies: [],
        currentDate: "",
        currentTime: "",
      };
    },
    mounted() {
      this.updateDateTime(); 
      setInterval(this.updateDateTime, 1000); 
      this.fetchDeliveryCompanies(); 
    },
    methods: {
      updateDateTime() {
        const now = new Date();
        this.currentDate = now.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        });
        this.currentTime = now.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      },
      async fetchDeliveryCompanies() {
    try {
        this.$root.isLoading = true;
        this.loading = true;
        const token = localStorage.getItem('authToken');
        const branchId = localStorage.getItem('branchId'); 
        
        if (!branchId) {
            throw new Error('Branch ID not found in localStorage');
        }

        const response = await fetch(
            `${this.$BASE_API_URL}/api/delivery_companies?branchId=${branchId}`, 
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (!response.ok) {
            throw new Error('Failed to fetch delivery companies');
        }

        const { data } = await response.json();
        this.deliveryCompanies = data;
    } catch (error) {
        console.error('Error fetching delivery companies:', error);
        this.$toast.error(error.message || 'Failed to load delivery companies data');
    } finally {
        this.$root.isLoading = false;
        this.loading = false;
    }
},
      navigateToAddDeliveryCompany() {
          if (!this.$hasPermission('create delivery companies')){
        this.$toast.error('Not Permitted');
        return;
    }
        this.$router.push({ name: "AddDeliverCompamiesComponent" });
      },
      handleEdit(company) {
        if (!this.$hasPermission('edit delivery companies')){
        this.$toast.error('Not Permitted');
        return;
    }
        this.$router.push({ 
          name: "EditDeliverCompamiesComponent", 
          params: { id: company.id } 
        });
      },
      async handleDelete(company) {
        if (!this.$hasPermission('delete delivery companies')){
        this.$toast.error('Not Permitted');
        return;
    }
        if (!confirm(`Are you sure you want to delete ${company.name_en}?`)) {
          return;
        }
        
        try {
          this.$root.isLoading = true; 
          this.loading = true;
          const token = localStorage.getItem('authToken');
          const response = await fetch(`${this.$BASE_API_URL}/api/delivery_companies/${company.id}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          });

          if (!response.ok) {
            throw new Error('Failed to delete delivery company');
          }

          this.deliveryCompanies = this.deliveryCompanies.filter(c => c.id !== company.id);
          this.$toast.success('Delivery company deleted successfully');
        } catch (error) {
          console.error('Error deleting delivery company:', error);
          this.$toast.error('Failed to delete delivery company');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
      async handleToggleStatus(company) {
        try {
          if(company.is_active){
            if (!this.$hasPermission('suspend delivery companies')){
        this.$toast.error('Not Permitted');
        return;
    }
          } else{
            if (!this.$hasPermission('activate delivery companies')){
        this.$toast.error('Not Permitted');
        return;
    }
          }
          this.$root.isLoading = true; 
          this.loading = true;
          const token = localStorage.getItem('authToken');
          const endpoint = company.is_active 
            ? `/api/delivery_companies/suspend/${company.id}`
            : `/api/delivery_companies/activate/${company.id}`;

          const response = await fetch(`${this.$BASE_API_URL}${endpoint}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          });

          if (!response.ok) {
            throw new Error('Failed to update delivery company status');
          }

          company.is_active = !company.is_active;
          this.$forceUpdate();
        } catch (error) {
          console.error('Error updating delivery company status:', error);
          this.$toast.error('Failed to update delivery company status');
        }
        finally {
      this.$root.isLoading = false;
      this.loading = false;
    }
      },
       handleRecordPayment(customer) {
      this.$router.push({ 
        name: "PaymentsComponent", 
        params: { customerId: customer.customerId },
      });
    },
    },
  };
  </script>
  
  <style scoped>
  .add-delivery-company-btn {
    float: right;
    margin-bottom: 10px;
    padding: 10px;
    background-color: #4caf50;
    color: white;
    border: none;
    cursor: pointer;
    width: max-content;
    border-radius: 5px;
    margin-right: .5rem;
    margin-top: 0.5rem;
  }
  .action-buttons {
    display: flex;
    gap: 8px;
    border-bottom: hidden;
    border-right: hidden;
  }
  .action-buttons button {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  .action-buttons button:hover {
    transform: scale(1.05);
  }
  .action-buttons button:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: -25px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 5px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
  }
  .action-buttons button img {
    width: 20px;
    height: 20px;
  }
  /* Status colors */
  .text-success {
    color: #28a745;
  }
  .text-danger {
    color: #dc3545;
  }
  /* Button colors */
  .delete-btn img {
    filter: invert(20%) sepia(100%) saturate(500%) hue-rotate(300deg);
  }
  .deactivate-btn {
    color: #dc3545;
  }
  .activate-btn {
    color: #28a745;
  }
  </style>